// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal--3q6zR","body":"body--1NYMF"};